/**
 * Origen único del precio.
 *
 * Existe porque el 8 de agosto de 2026 subir el precio con la variable de
 * entorno `PRICE_INDIVIDUAL` dejó la web anunciando 19,90 € mientras Stripe
 * cobraba 39 €: el número estaba escrito a mano en cinco sitios de `seo.ts`,
 * uno en la tabla de las condiciones legales y dos como valor por defecto del
 * cliente, y `promo.js` solo los corregía si había una promoción activa.
 *
 * Regla: ningún precio se escribe a mano en ninguna plantilla. Todo sale de
 * aquí, y `tools/check.ts` comprueba que el valor por defecto de `server/index.js`
 * coincide con este, porque el servidor es JavaScript plano y no puede importarlo.
 *
 * `PRICE_INDIVIDUAL` en el entorno sigue funcionando como palanca de urgencia
 * en el VPS, pero solo cambia lo que se cobra y lo que sirve `/api/config`: las
 * páginas estáticas se compilan con este número. Si se usa, hay que desplegar
 * después para que el HTML vuelva a decir la verdad.
 */

/** Acceso individual completo, en céntimos. Pago único, IVA incluido. */
export const PRECIO_INDIVIDUAL = 3900;

/** Asiento de flota, en céntimos. Mínimo dos. */
export const PRECIO_ASIENTO_FLOTA = 1500;

/** «39,00 €». Formato español, para plantillas y para la interfaz. */
export function euros(centimos: number): string {
  return (centimos / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
}
